export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.updatedAt': 'Update at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.update': 'Update',
  'pages.searchTable.clone': 'Clone',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.searchTable.delete': 'Delete',
  'pages.bomSpec.code': 'Code',
  'pages.bomSpec.name': 'Name',
  'pages.bomSpec.isActive': 'Active',
  'pages.bomSpec.type': 'Type',
  'pages.bomSpec.type.weaveStyle': 'Weave Style',
  'pages.bomSpec.type.paintingStyle': 'Paint Style',
  'pages.bomSpec.updatedAt': 'Updated At',
  'pages.bomSpec.createForm.title': 'New Bom Spec',
  'pages.bomSpec.updateForm.title': 'Update Bom Spec',
  'pages.itemType.code': 'Code',
  'pages.itemType.name': 'Name',
  'pages.itemType.isActive': 'Active',
  'pages.itemType.updatedAt': 'Updated At',
  'pages.itemType.createForm.title': 'New Item Type',
  'pages.itemType.updateForm.title': 'Update Item Type',
  'pages.item.code': 'Code',
  'pages.item.name': 'Name',
  'pages.item.itemTypeId': 'Item Type',
  'pages.item.imageUrl': 'Image',
  'pages.item.isActive': 'Active',
  'pages.item.updatedAt': 'Updated At',
  'pages.item.createForm.title': 'New Item',
  'pages.item.updateForm.title': 'Update Item',
  'pages.supplier.code': 'Code',
  'pages.supplier.name': 'Name',
  'pages.supplier.updatedAt': 'Updated At',
  'pages.supplier.createForm.title': 'New Supplier',
  'pages.supplier.updateForm.title': 'Update Supplier',
  'pages.criteria.code': 'Code',
  'pages.criteria.name': 'Name',
  'pages.criteria.criteriaGroupId': 'Group',
  'pages.criteria.isDefault': 'Default',
  'pages.criteria.sortIndex': 'Sort',
  'pages.criteria.isActive': 'Active',
  'pages.criteria.updatedAt': 'Updated At',
  'pages.criteria.createForm.title': 'New Criteria',
  'pages.criteria.updateForm.title': 'Update Criteria',
  'pages.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.delete.ok': 'Delete',
  'pages.delete.cancel': 'Cancel',
  'pages.qcStandard.code': 'Code',
  'pages.qcStandard.product': 'Product',
  'pages.qcStandard.item': 'Item',
  'pages.qcStandard.material': 'Material',
  'pages.qcStandard.bomSpec': 'BOM Spec',
  'pages.qcStandard.size': 'Size',
  'pages.qcStandard.color': 'Color',
  'pages.qcStandard.date': 'Date',
  'pages.qcStandard.status': 'Status',
  'pages.qcStandard.status.draft': 'Draft',
  'pages.qcStandard.status.pending': 'Pending',
  'pages.qcStandard.status.approved': 'Approved',
  'pages.qcStandard.status.rejected': 'Rejected',
  'pages.qcStandard.updatedAt': 'Updated At',
  'pages.qcStandard.createForm.title': 'Create Qc Standard',
  'pages.qcStandard.updateForm.title': 'Update Qc Standard',
  'pages.qcStandard.details': 'Qc Standard Details',
  'pages.qcStandard.create': 'Create',
  'pages.qcStandard.update': 'Update',
  'pages.qcStandard.cancel': 'Cancel',
  'pages.qcStandard.approve': 'Approve',
  'pages.qcStandard.reject': 'Reject',
  'pages.qcStandard.delete': 'Delete',
  'pages.qcStandard.delete.confirm': 'Are you sure to delete?',
  'pages.qcStandard.delete.ok': 'Delete',
  'pages.qcStandard.delete.cancel': 'Cancel',
  'pages.qcStandard.save': 'Save',
  'pages.qcStandardDetail.image': 'Image',
  'pages.qcStandardDetail.criteria': 'Criteria',
  'pages.qcStandardDetail.description': 'Description',
  'pages.qcStandardDetail.add': 'Add Row',
  'pages.qcStandardDetail.remove': 'Remove',
  'pages.productionOrder.code': 'Order Code',
  'pages.productionOrder.date': 'Order Date',
  'pages.productionOrder.supplierName': 'Supplier',
  'pages.productionOrder.status': 'Status',
  'pages.productionOrder.status.draft': 'Draft',
  'pages.productionOrder.status.pending': 'Pending',
  'pages.productionOrder.status.approved': 'Approved',
  'pages.productionOrder.status.rejected': 'Rejected',
  'pages.productionOrder.updatedAt': 'Updated At',
  'pages.productionOrder.createForm.title': 'New Production Order',
  'pages.productionOrder.updateForm.title': 'Update Production Order',
  'pages.productionOrder.details': 'Production Order Details',
  'pages.productionOrder.create': 'Create',
  'pages.productionOrder.update': 'Update',
  'pages.productionOrder.cancel': 'Cancel',
  'pages.productionOrder.delete.confirm': 'Are you sure to delete?',
  'pages.productionOrder.delete.ok': 'Delete',
  'pages.productionOrder.delete.cancel': 'Cancel',
  'pages.productionOrderProduct.image': 'Image',
  'pages.productionOrderProduct.product': 'Product',
  'pages.productionOrderProduct.uom': 'UOM',
  'pages.productionOrderProduct.quantity': 'Quantity',
  'pages.productionOrderDetail.image': 'Image',
  'pages.productionOrderDetail.itemName': 'Item',
  'pages.productionOrderDetail.uom': 'UOM',
  'pages.productionOrderDetail.quantity': 'Quantity',
  'pages.productionOrderDetail.unitPrice': 'Unit Price',
  'pages.productionOrderDetail.amount': 'Amount',
  'pages.productionOrderForApproval.approving': 'Approving...',
  'pages.productionOrderForApproval.approved.success': 'Approved successfully',
  'pages.productionOrderForApproval.approved.failed': 'Approve failed, please try again!',
  'pages.productionOrderForApproval.rejecting': 'Rejecting...',
  'pages.productionOrderForApproval.rejected.success': 'Rejected successfully',
  'pages.productionOrderForApproval.rejected.failed': 'Reject failed, please try again!',
  'pages.productionOrderForApproval.expand': 'Expand',
  'pages.productionOrderForApproval.collapse': 'Collapse',
  'pages.productionOrderForApproval.itemName': 'Item Name',
  'pages.productionOrderForApproval.itemName.placeholder': 'Enter item name',
  'pages.productionOrderForApproval.deliveryDate': 'Delivery Date',
  'pages.productionOrderForApproval.deliveryDate.placeholder': 'Select delivery date',
  'pages.productionOrderForApproval.supplierName': 'Supplier Name',
  'pages.productionOrderForApproval.supplierName.placeholder': 'Enter supplier name',
  'pages.productionOrderForApproval.productionOrderCode': 'Production Order',
  'pages.productionOrderForApproval.productionOrderCode.placeholder': 'Enter production order',
  'pages.productionOrderForApproval.quantity': 'Quantity',
  'pages.productionOrderForApproval.unitPrice': 'Unit Price',
  'pages.productionOrderForApproval.amount': 'Amount',
  'pages.productionOrderForApproval.deliveryDate.label': 'Delivery Date',
  'pages.productionOrderForApproval.description': 'Description',
  'pages.productionOrderForApproval.loadedAll': 'All data loaded',
  'pages.productionOrderForApproval.approve': 'Approve',
  'pages.productionOrderForApproval.reject': 'Reject',
  'pages.productionOrderForSupplier.expand': 'Expand',
  'pages.productionOrderForSupplier.collapse': 'Collapse',
  'pages.productionOrderForSupplier.itemName': 'Item Name',
  'pages.reports.chart.type.planAmount': 'Total Plan Amount',
  'pages.reports.chart.type.approvedAmount': 'Total Approved Amount',
  'pages.reports.chart.type.pendingAmount': 'Total Pending Amount',
  'pages.reports.chart.type.approvedAmountNotPlan': 'Approved Amount (No Plan)',
  'pages.reports.chart.type.pendingAmountNotPlan': 'Pending Amount (No Plan)',
  'pages.reports.title': 'Reports',
  'pages.reports.organization': 'Budget by Organization',
  'pages.reports.organizationDetail': 'Organization Detail',
  'pages.reports.organizationDetail.placeholder': 'Select organization detail',
  'pages.reports.period': 'Period',
  'pages.reports.period.yearly': 'Yearly',
  'pages.reports.period.quarterly': 'Quarterly',
  'pages.reports.period.monthly': 'Monthly',
  'pages.reports.year': 'Year',
  'pages.reports.year.placeholder': 'Select year',
  'pages.reports.quarter': 'Quarter',
  'pages.reports.quarter.placeholder': 'Select quarter',
  'pages.reports.month': 'Month',
  'pages.reports.month.placeholder': 'Select month',
  'pages.reports.search': 'Search',
  'pages.reports.totalPlanAmount': 'Total Plan Amount',
  'pages.reports.totalApprovedAmount': 'Total Approved Amount',
  'pages.reports.totalPendingAmount': 'Total Pending Amount',
  'pages.reports.totalBalanceAmount': 'Total Balance Amount',
  'pages.reports.consumedPercentage': 'Consumed Percentage',
  'pages.reports.totalRequest': 'Total Request',
  'pages.reports.details': 'Details',

  'pages.reports.costItem': 'Cost Item',
  'pages.reports.planAmount': 'Plan Amount',
  'pages.reports.approvedAmount': 'Approved Amount',
  'pages.reports.pendingAmount': 'Pending Amount',
  'pages.reports.balanceAmount': 'Balance Amount',
  'pages.reports.table': 'Table',
  'pages.reports.charts': 'Charts',
  'pages.reports.matrix': 'Matrix',
  'pages.reports.noData': 'No data available. Please select filters and search to view results.',
  'pages.reports.chart.column': 'Column Chart',
  'pages.reports.chart.column.title': 'Plan Amount by Cost Items',
  'pages.reports.chart.pie': 'Pie Chart',
  'pages.reports.chart.pie.title': 'Plan Amount Distribution by Category',
  'pages.reports.chart.line': 'Line Chart',
  'pages.reports.chart.line.title': 'Plan Amount Trends',
  'pages.reports.chart.dual': 'Dual Axes Chart',
  'pages.reports.chart.dual.title': 'Plan vs Approved Amount Comparison',
  'pages.reports.chart.byPeriod': 'By Period',
  'pages.reports.chart.byOrganization': 'By Organization',
  'pages.reports.matrix.organizationView': 'Organization View',
  'pages.reports.matrix.costView': 'Cost View',
  'pages.reports.costCategory.placeholder': 'Select cost category',
  'pages.reports.costItem.placeholder': 'Select cost item',

  'pages.reports.organizationDetailParent': 'Organization Detail Parent',
  'pages.reports.summary': 'Summary Report',
  'pages.reports.type': 'Type',
  'pages.reports.type.placeholder': 'Select type',
  'pages.reports.type.all': 'All Types',
  'pages.reports.type.expense': 'Expense',
  'pages.reports.type.income': 'Income',
  'pages.reports.organizationLevel': 'Organization Level',
  'pages.reports.organizationLevel.placeholder': 'Select organization level',
  'pages.reports.organizationLevel.all': 'All Levels',
  'pages.reports.organizationLevel.level1': 'Level 1',
  'pages.reports.organizationLevel.level2': 'Level 2',
  'pages.reports.organizationLevel.level3': 'Level 3',
  // Plan module
  'pages.plan.code': 'Code',
  'pages.plan.fromDate': 'From Date',
  'pages.plan.toDate': 'To Date',
  'pages.plan.organizationDetail': 'Organization Detail',
  'pages.plan.description': 'Description',
  'pages.plan.totalAmount': 'Total Amount',
  'pages.plan.updatedAt': 'Updated At',
  'pages.plan.view.title': 'View Plan',
  'pages.plan.create.title': 'Create Plan',
  'pages.plan.update.title': 'Update Plan',
  'pages.plan.code.placeholder': 'Enter code',
  'pages.plan.organizationDetail.placeholder': 'Select organization detail',
  'pages.plan.fromDate.placeholder': 'Select from date',
  'pages.plan.toDate.placeholder': 'Select to date',
  'pages.plan.description.placeholder': 'Enter description',
  'pages.plan.totalAmount.placeholder': 'Total amount will be calculated automatically',
  'pages.plan.organizationDetail.search.placeholder': 'Select organization detail',
  'pages.plan.details': 'Plan Details',
  'pages.plan.details.add': 'Add Detail',
  'pages.plan.details.delete': 'Delete Detail',
  'pages.plan.detail.costItem': 'Cost Item',
  'pages.plan.detail.costItem.placeholder': 'Select cost item',
  'pages.plan.detail.amount': 'Amount',
  'pages.plan.detail.amount.placeholder': 'Enter amount',
  'pages.plan.detail.description': 'Description',
  'pages.plan.detail.description.placeholder': 'Enter description',
  'pages.plan.status': 'Status',
  'pages.plan.status.draft': 'Draft',
  'pages.plan.status.pending': 'Pending',
  'pages.plan.status.approved': 'Approved',
  'pages.plan.status.rejected': 'Rejected',
  'pages.plan.status.canceled': 'Canceled',
  'pages.plan.reason': 'Reason',
  'pages.plan.createdAt': 'Created At',
  'pages.plan.approve': 'Approve',
  'pages.plan.reject': 'Reject',
  'pages.plan.reject.reason': 'Rejection Reason',
  'pages.plan.reject.confirm': 'Confirm',
  'pages.plan.reject.cancel': 'Cancel',
  'pages.plan.reject.reason.placeholder': 'Enter rejection reason (required)...',
  'pages.plan.cancel': 'Cancel',
  'pages.plan.cancel.reason': 'Cancellation Reason',
  'pages.plan.cancel.confirm': 'Confirm',
  'pages.plan.cancel.cancel': 'Cancel',
  'pages.plan.cancel.reason.required': 'Please enter the cancellation reason',
  'pages.plan.cancel.reason.placeholder': 'Enter cancellation reason (required)...',
  'pages.plan.bulkReject.title': 'Bulk Reject Plans',
  'pages.plan.bulkReject.description': 'Are you sure you want to bulk reject these plans?',
  'pages.plan.bulkReject.reason': 'Reason for bulk reject:',
  'pages.plan.bulkReject.reasonPlaceholder': 'Enter reason for bulk reject',
  'pages.plan.bulkCancel.title': 'Bulk Cancel Plans',
  'pages.plan.bulkCancel.description': 'Are you sure you want to bulk cancel these plans?',
  'pages.plan.bulkCancel.reason': 'Reason for bulk cancel:',
  'pages.plan.bulkCancel.reasonPlaceholder': 'Enter reason for bulk cancel',
  'pages.plan.downloadTemplate': 'Download Template',
  'pages.plan.import': 'Import',
  'pages.plan.actions': 'Actions',
  'pages.productionOrderForSupplier.itemName.placeholder': 'Enter item name',
  'pages.productionOrderForSupplier.deliveryDate': 'Delivery Date',
  'pages.productionOrderForSupplier.deliveryDate.placeholder': 'Select delivery date',
  'pages.productionOrderForSupplier.supplierName': 'Supplier Name',
  'pages.productionOrderForSupplier.supplierName.placeholder': 'Enter supplier name',
  'pages.productionOrderForSupplier.productionOrderCode': 'Production Order',
  'pages.productionOrderForSupplier.productionOrderCode.placeholder': 'Enter production order',
  'pages.productionOrderForSupplier.loadedAll': 'All data loaded',
  'pages.productionOrderOutput.code.label': 'Code',
  'pages.productionOrderOutput.code.placeholder': 'Enter code',
  'pages.productionOrderOutput.code.required': 'Code is required',
  'pages.productionOrderOutput.date.label': 'Date',
  'pages.productionOrderOutput.date.placeholder': 'Select date',
  'pages.productionOrderOutput.date.required': 'Date is required',
  'pages.productionOrderOutput.supplierId.label': 'Supplier',
  'pages.productionOrderOutput.supplierId.placeholder': 'Select supplier',
  'pages.productionOrderOutput.supplierId.required': 'Supplier is required',
  'pages.productionOrderOutput.integrationId.label': 'Integration Id',
  'pages.productionOrderOutput.integrationId.placeholder': 'Enter Integration Id',
  'pages.productionOrderOutput.integrationId.required': 'Integration Id is required',
  'pages.productionOrderOutput.productId.label': 'Product',
  'pages.productionOrderOutput.productId.required': 'Please select a product',
  'pages.productionOrderOutput.quantity.label': 'Quantity',
  'pages.productionOrderOutput.quantity.required': 'Quantity is required',
  'pages.productionOrderOutput.uom.label': 'UOM',
  'pages.productionOrderOutput.uom.required': 'UOM is required',
  'pages.productionOrderOutput.notes.label': 'Notes',
  'pages.productionOrderOutput.notes.placeholder': 'Enter notes',
  'pages.productionOrderOutput.isSync.label': 'Sync',
  'pages.productionOrderOutput.addProduct': 'Add product',
  'pages.productionOrderOutput.remove': 'Remove',
  'pages.productionOrderOutputQc.approving': 'Approving...',
  'pages.productionOrderOutputQc.approved.success': 'Approved successfully',
  'pages.productionOrderOutputQc.approved.failed': 'Approve failed, please try again!',
  'pages.productionOrderOutputQc.rejecting': 'Rejecting...',
  'pages.productionOrderOutputQc.rejected.success': 'Rejected successfully',
  'pages.productionOrderOutputQc.rejected.failed': 'Reject failed, please try again!',
  'pages.productionOrderOutputQc.standard': 'Standard',
  'pages.productionOrderOutputQc.actual': 'Actual',
  'pages.productionOrderOutputQc.notes.placeholder': 'Notes',
  'pages.productionOrderOutputQc.submit.success': 'Submitted',
  'pages.supplier.details': 'Details',
  'pages.supplier.delete.ok': 'Delete',
  'pages.supplier.delete.cancel': 'Cancel',
  'pages.supplier.create': 'Create',
  'pages.supplier.update': 'Update',
  'pages.supplier.cancel': 'Cancel',
  'pages.supplier.code.required': 'Code is required',
  'pages.supplier.name.required': 'Name is required',
  'pages.supplier.save': 'Save',
  'pages.supplier.inactive': 'Inactive',
  'pages.criteriaGroup.details': 'Details',
  'pages.criteriaGroup.delete.confirm': 'Are you sure to delete?',
  'pages.criteriaGroup.delete.ok': 'Delete',
  'pages.criteriaGroup.delete.cancel': 'Cancel',
  'pages.criteriaGroup.create': 'Create',
  'pages.criteriaGroup.update': 'Update',
  'pages.criteriaGroup.cancel': 'Cancel',
  'pages.criteriaGroup.code.required': 'Code is required',
  'pages.criteriaGroup.name.required': 'Name is required',
  'pages.criteriaGroup.save': 'Save',
  'pages.criteriaGroup.inactive': 'Inactive',
  'pages.item.details': 'Details',
  'pages.item.delete.confirm': 'Are you sure to delete?',
  'pages.item.delete.ok': 'Delete',
  'pages.item.delete.cancel': 'Cancel',
  'pages.item.create': 'Create',
  'pages.item.update': 'Update',
  'pages.item.cancel': 'Cancel',
  'pages.item.code.required': 'Code is required',
  'pages.item.name.required': 'Name is required',
  'pages.item.itemTypeId.required': 'Please select an item type',
  'pages.item.save': 'Save',
  'pages.item.inactive': 'Inactive',
  'pages.itemType.details': 'Details',
  'pages.itemType.delete.confirm': 'Are you sure to delete?',
  'pages.itemType.delete.ok': 'Delete',
  'pages.itemType.delete.cancel': 'Cancel',
  'pages.itemType.create': 'Create',
  'pages.itemType.update': 'Update',
  'pages.itemType.cancel': 'Cancel',
  'pages.itemType.code.required': 'Code is required',
  'pages.itemType.name.required': 'Name is required',
  'pages.itemType.save': 'Save',
  'pages.itemType.inactive': 'Inactive',  
  'pages.criteriaGroup.name': 'Name',
  'pages.criteriaGroup.code': 'Code',
  'pages.criteriaGroup.isActive': 'Active',
  'pages.criteriaGroup.updatedAt': 'Updated At',
  'pages.productionOrderForApproval.sampleMark': 'Sample',
  'pages.productionOrderForApproval.card.quantity': 'Quantity',
  'pages.productionOrderForApproval.card.unitPrice': 'Unit Price',
  'pages.productionOrderForApproval.card.amount': 'Amount',
  'pages.productionOrderForApproval.card.deliveryDate': 'Delivery Date',
  'pages.productionOrderForApproval.card.uom': 'UOM',
  'pages.productionOrderForApproval.card.vnd': 'VND',
  'pages.productionOrderForApproval.card.view': 'View',
  'pages.productionOrderForApproval.card.noImage': 'No image',
  'pages.productionOrderForApproval.card.sample': 'Sample',
  'pages.productionOrderForApproval.card.loader': 'All data loaded',
  'pages.productionOrderForApproval.button.reject': 'Reject',
  'pages.productionOrderForApproval.button.approve': 'Approve',
  'pages.productionOrderForSupplier.sampleMark': 'Sample',
  'pages.productionOrderForSupplier.card.done': 'Done',
  'pages.productionOrderForSupplier.card.of': 'of',
  'pages.productionOrderForSupplier.card.uom': 'UOM',
  'pages.productionOrderForSupplier.card.vnd': 'VND',
  'pages.productionOrderForSupplier.card.view': 'View',
  'pages.productionOrderForSupplier.card.noImage': 'No image',
  'pages.productionOrderForSupplier.card.sample': 'Sample',
  'pages.productionOrderForSupplier.card.loader': 'All data loaded',
  'pages.productionOrderForSupplier.table.standard': 'Standard',
  'pages.productionOrderForSupplier.table.actual': 'Actual',
  'pages.productionOrderForSupplier.table.notes': 'Notes',
  'pages.productionOrderForSupplier.button.cancel': 'Cancel',
  'pages.productionOrderForSupplier.button.save': 'Save',
  'pages.productionOrderForSupplier.segmented.pass': 'Pass',
  'pages.productionOrderForSupplier.segmented.fail': 'Fail',
  'pages.productionOrderForSupplier.message.submitted': 'Submitted',
  'pages.productionOrderOutputQc.table.standard': 'Standard',
  'pages.productionOrderOutputQc.table.actual': 'Actual',
  'pages.productionOrderOutputQc.table.notes': 'Notes',
  'pages.productionOrderOutputQc.button.cancel': 'Cancel',
  'pages.productionOrderOutputQc.button.save': 'Save',
  'pages.productionOrderOutputQc.button.approve': 'Approve',
  'pages.productionOrderOutputQc.button.reject': 'Reject',
  'pages.productionOrderOutputQc.button.reQc': 'Re-QC',
  'pages.productionOrderOutputQc.segmented.pass': 'Pass',
  'pages.productionOrderOutputQc.segmented.fail': 'Fail',
  'pages.productionOrderOutputQc.switch.passed': 'Passed',
  'pages.productionOrderOutputQc.switch.failed': 'Failed',
  'pages.productionOrderOutputQc.message.submitted': 'Submitted',
  'pages.productionOrderOutputQc.imageUrl': 'Image',
  'pages.productionOrderOutputQc.outputCode': 'Output Code',
  'pages.productionOrderOutputQc.code': 'Code',
  'pages.productionOrderOutputQc.date': 'Date',
  'pages.productionOrderOutputQc.itemName': 'Item',
  'pages.productionOrderOutputQc.outputQuantity': 'Output Quantity',
  'pages.productionOrderOutputQc.isPassed': 'Result',
  'pages.productionOrderOutputQc.isReQc': 'Re-QC',
  'pages.productionOrderOutputQc.status': 'Status',
  'pages.productionOrderOutputQc.updatedAt': 'Updated At',
  'pages.productionOrderOutputQc.status.draft': 'Draft',
  'pages.productionOrderOutputQc.status.pending': 'Pending',
  'pages.productionOrderOutputQc.status.approved': 'Approved',
  'pages.productionOrderOutputQc.status.rejected': 'Rejected',
  'pages.productionOrderOutput.code': 'Code',
  'pages.productionOrderOutput.date': 'Date',
  'pages.productionOrderOutput.supplierName': 'Supplier',
  'pages.productionOrderOutput.status': 'Status',
  'pages.productionOrderOutput.status.draft': 'Draft',
  'pages.productionOrderOutput.status.pending': 'Pending',
  'pages.productionOrderOutput.status.approved': 'Approved',
  'pages.productionOrderOutput.status.rejected': 'Rejected',
  'pages.productionOrderOutput.updatedAt': 'Updated At',
  'pages.productionOrderOutput.createForm.title': 'New Production Order Output',
  'pages.productionOrderOutput.updateForm.title': 'Update Production Order Output',
  'pages.productionOrderOutput.details': 'Production Order Output Details',
  'pages.productionOrderOutput.create': 'Create',
  'pages.productionOrderOutput.update': 'Update',
  'pages.productionOrderOutput.cancel': 'Cancel',
  'pages.productionOrderOutput.delete.confirm': 'Are you sure to delete?',
  'pages.productionOrderOutput.delete.ok': 'Delete',
  'pages.productionOrderOutput.delete.cancel': 'Cancel',
  'pages.productionOrderOutput.save': 'Save',
  'pages.productionOrderOutput.inactive': 'Inactive',
  'pages.productionOrderOutput.quantity': 'Quantity',
  'pages.productionOrderOutput.itemName': 'Item',
  'pages.productionOrderOutput.productionOrderDetailUom': 'UOM',
  'pages.productionOrderOutput.productionOrderDetailQuantity': 'Quantity',
  'pages.productionOrderOutput.productionOrderDetailUnitPrice': 'Unit Price',
  'pages.productionOrderOutput.productionOrderDetailAmount': 'Amount',
  'pages.productionOrderOutput.itemName.placeholder': 'Enter item name',
  'pages.productionOrderOutput.notes': 'Notes',
  'pages.productionOrderOutput.isSync': 'Sync',
  'pages.productionOrderOutputQc.qcStandardCode': 'Standard',
  'pages.productionOrderOutputQcDetail.qcStandardDetailImageUrl': 'Standard',
  'pages.productionOrderOutputQcDetail.imageUrl': 'Actual',
  'pages.productionOrderOutput.form.code': 'Code',
  'pages.productionOrderOutput.form.code.placeholder': 'Enter code',
  'pages.productionOrderOutput.form.code.required': 'Code is required',
  'pages.productionOrderOutput.form.date': 'Date',
  'pages.productionOrderOutput.form.date.placeholder': 'Select date',
  'pages.productionOrderOutput.form.date.required': 'Date is required',
  'pages.productionOrderOutput.form.supplier': 'Supplier',
  'pages.productionOrderOutput.form.supplier.required': 'Supplier is required',
  'pages.productionOrderOutput.form.integrationId': 'Integration Id',
  'pages.productionOrderOutput.form.integrationId.placeholder': 'Enter Integration Id',
  'pages.productionOrderOutput.form.integrationId.required': 'Integration Id is required',
  'pages.productionOrderOutput.form.productList.add': 'Add product',
  'pages.productionOrderOutput.form.productList.remove': 'Remove',
  'pages.productionOrderOutput.form.productList.label': 'Product #{index}',
  'pages.productionOrderOutput.form.product': 'Product',
  'pages.productionOrderOutput.form.product.required': 'Product is required',
  'pages.productionOrderOutput.form.quantity': 'Quantity',
  'pages.productionOrderOutput.form.quantity.placeholder': 'Enter quantity',
  'pages.productionOrderOutput.form.quantity.required': 'Quantity is required',
  'pages.productionOrderOutput.form.uom': 'UOM',
  'pages.productionOrderOutput.form.uom.required': 'UOM is required',
  'pages.qcStandard.reject.reason.required': 'Please enter the rejection reason',
  'pages.qcStandard.reject.confirm': 'Confirm',
  'pages.qcStandard.reject.cancel': 'Cancel',
  'pages.qcStandard.reject.reason': 'Rejection Reason',
  'pages.qcStandard.reject.reason.placeholder': 'Enter rejection reason (required)...',
  'pages.productionOrderForApproval.reject.reason': 'Rejection Reason',
  'pages.productionOrderForApproval.reject.reason.placeholder': 'Enter rejection reason (required)...',
  'pages.productionOrderForApproval.reject.confirm': 'Confirm',
  'pages.productionOrderForApproval.reject.cancel': 'Cancel',
  'pages.productionOrder.status.saved': 'Saved',
  'pages.productionOrder.status.canceled': 'Canceled',
  'pages.productionOrderOutput.productionOrderCode': 'Production Order',
  'pages.productionOrderForApproval.fromDeliveryDate.placeholder': 'Select from date',
  'pages.productionOrderForApproval.toDeliveryDate.placeholder': 'Select to date',
  'pages.productionOrderForSupplier.fromDeliveryDate.placeholder': 'Select from date',
  'pages.productionOrderForSupplier.toDeliveryDate.placeholder': 'Select to date',
  'pages.productionOrderForSupplier.qcDetails.incomplete': 'Please fill out all QC details',
  'pages.searchTable.print': 'Print',
  'pages.organization.code': 'Code',
  'pages.organization.name': 'Name',
  'pages.organization.parent': 'Parent Organization',
  'pages.organization.parent.search.placeholder': 'Select parent organization',
  'pages.organization.level': 'Level',
  'pages.organization.updatedAt': 'Updated At',
  'pages.organization.createdAt': 'Created At',
  'pages.organization.createForm.title': 'Create New Organization',
  'pages.organization.updateForm.title': 'Update Organization',
  'pages.organization.details': 'Organization Details',
  'pages.organization.update': 'Update',
  'pages.organization.delete.confirm': 'Are you sure you want to delete?',
  'pages.organization.delete.ok': 'Delete',
  'pages.organization.delete.cancel': 'Cancel',
  'pages.organization.save': 'Save',
  'pages.organization.cancel': 'Cancel',
  'pages.organization.parent.placeholder': 'Select parent organization (only shows organizations with lower levels)',
  'pages.organization.title': 'Organization',
  'pages.organization.column.code': 'Code',
  'pages.organization.column.name': 'Name',
  'pages.organization.column.level': 'Level',
  'pages.organization.column.parent': 'Parent',
  'pages.organization.column.isActive': 'Is Active',
  'pages.organization.validation.codeRequired': 'Code is required',
  'pages.organization.validation.nameRequired': 'Name is required',
  'pages.organization.validation.levelRequired': 'Level is required',
  'pages.organization.validation.parentRequired': 'Parent is required for level > 1',
  'pages.organization.validation.tooltip': 'Fix required fields (code, name, level, parent for level>1)',
  'pages.organization.select.parent.placeholder': 'Select parent (lower level)',
  'pages.organization.active': 'Active',
  'pages.organization.inactive': 'InActive',
  'pages.organization.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.organization.message.newRecordRemoved': 'New record removed successfully',
  'pages.organization.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.organization.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.organization.message.noChangesToSync': 'No changes to sync',
  'pages.organization.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.organization.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.organization.message.fetchError': 'Failed to fetch organizations',
  'pages.organization.refresh.success': 'Data refreshed successfully.',
  'pages.organization.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.organization.refresh.tooltip': 'Refresh will discard unsaved changes',
  'pages.organization.refresh.tooltip.normal': 'Refresh data from server',
  
  // Origin Detail
  'pages.origin.title': 'Origin Detail',
  'pages.origin.column.code': 'Code',
  'pages.origin.column.name': 'Name',
  'pages.origin.column.isActive': 'Is Active',
  'pages.origin.validation.codeRequired': 'Code is required',
  'pages.origin.validation.nameRequired': 'Name is required',
  'pages.origin.active': 'Active',
  'pages.origin.inactive': 'InActive',
  'pages.origin.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.origin.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.origin.message.newRecordRemoved': 'New record removed successfully',
  'pages.origin.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.origin.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.origin.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.origin.message.noChangesToSync': 'No changes to sync',
  'pages.origin.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.origin.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.origin.message.fetchError': 'Failed to fetch origins',
  'pages.origin.refresh.success': 'Data refreshed successfully.',
  'pages.origin.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.origin.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.origin.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.origin.refresh.tooltip.normal': 'Refresh data from server',
  
  // Size Detail
  'pages.size.title': 'Size Detail',
  'pages.size.column.code': 'Code',
  'pages.size.column.name': 'Name',
  'pages.size.column.description': 'Description',
  'pages.size.column.isActive': 'Is Active',
  'pages.size.validation.codeRequired': 'Code is required',
  'pages.size.validation.nameRequired': 'Name is required',
  'pages.size.active': 'Active',
  'pages.size.inactive': 'InActive',
  'pages.size.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.size.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.size.message.newRecordRemoved': 'New record removed successfully',
  'pages.size.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.size.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.size.message.noChangesToSync': 'No changes to sync',
  'pages.size.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.size.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.size.message.fetchError': 'Failed to fetch sizes',
  'pages.size.refresh.success': 'Data refreshed successfully.',
  'pages.size.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.size.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.size.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.size.refresh.tooltip.normal': 'Refresh data from server',

  // Job Position Detail
  'pages.jobPosition.title': 'Job Position',
  'pages.jobPosition.column.code': 'Code',
  'pages.jobPosition.column.name': 'Name',
  'pages.jobPosition.column.description': 'Description',
  'pages.jobPosition.column.isActive': 'Is Active',
  'pages.jobPosition.validation.codeRequired': 'Code is required',
  'pages.jobPosition.validation.nameRequired': 'Name is required',
  'pages.jobPosition.active': 'Active',
  'pages.jobPosition.inactive': 'InActive',
  'pages.jobPosition.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.jobPosition.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.jobPosition.message.newRecordRemoved': 'New record removed successfully',
  'pages.jobPosition.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.jobPosition.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.jobPosition.message.noChangesToSync': 'No changes to sync',
  'pages.jobPosition.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.jobPosition.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.jobPosition.message.fetchError': 'Failed to fetch job positions',
  'pages.jobPosition.message.apiNotAvailable': 'API not available yet. Changes not saved.',
  'pages.jobPosition.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.jobPosition.refresh.success': 'Data refreshed successfully.',
  'pages.jobPosition.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.jobPosition.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.jobPosition.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.jobPosition.refresh.tooltip.normal': 'Refresh data from server',

  // Light Source Detail
  'pages.lightSource.title': 'Light Source',
  'pages.lightSource.column.code': 'Code',
  'pages.lightSource.column.name': 'Name',
  'pages.lightSource.column.description': 'Description',
  'pages.lightSource.column.isActive': 'Is Active',
  'pages.lightSource.validation.codeRequired': 'Code is required',
  'pages.lightSource.validation.nameRequired': 'Name is required',
  'pages.lightSource.active': 'Active',
  'pages.lightSource.inactive': 'InActive',
  'pages.lightSource.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.lightSource.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.lightSource.message.newRecordRemoved': 'New record removed successfully',
  'pages.lightSource.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.lightSource.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.lightSource.message.noChangesToSync': 'No changes to sync',
  'pages.lightSource.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.lightSource.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.lightSource.message.fetchError': 'Failed to fetch job positions',
  'pages.lightSource.message.apiNotAvailable': 'API not available yet. Changes not saved.',
  'pages.lightSource.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.lightSource.refresh.success': 'Data refreshed successfully.',
  'pages.lightSource.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.lightSource.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.lightSource.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.lightSource.refresh.tooltip.normal': 'Refresh data from server',

  // Section Detail
  'pages.section.title': 'Section',
  'pages.section.column.code': 'Code',
  'pages.section.column.name': 'Name',
  'pages.section.column.description': 'Description',
  'pages.section.column.isActive': 'Is Active',
  'pages.section.validation.codeRequired': 'Code is required',
  'pages.section.validation.nameRequired': 'Name is required',
  'pages.section.active': 'Active',
  'pages.section.inactive': 'InActive',
  'pages.section.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.section.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.section.message.newRecordRemoved': 'New record removed successfully',
  'pages.section.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.section.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.section.message.noChangesToSync': 'No changes to sync',
  'pages.section.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.section.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.section.message.fetchError': 'Failed to fetch sections',
  'pages.section.message.apiNotAvailable': 'API not available yet. Changes not saved.',
  'pages.section.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.section.refresh.success': 'Data refreshed successfully.',
  'pages.section.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.section.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.section.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.section.refresh.tooltip.normal': 'Refresh data from server',
  
  // UOM Detail
  'pages.uom.title': 'UOM Detail',
  'pages.uom.column.code': 'Code',
  'pages.uom.column.name': 'Name',
  'pages.uom.column.decimalPlaces': 'Decimal Places',
  'pages.uom.column.orderDecimalPlaces': 'Order Decimal Places',
  'pages.uom.column.isActive': 'Is Active',
  'pages.uom.validation.codeRequired': 'Code is required',
  'pages.uom.validation.nameRequired': 'Name is required',
  'pages.uom.validation.decimalPlacesRequired': 'Decimal places is required',
  'pages.uom.validation.orderDecimalPlacesRequired': 'Order decimal places is required',
  'pages.uom.active': 'Active',
  'pages.uom.inactive': 'InActive',
  'pages.uom.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.uom.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.uom.message.newRecordRemoved': 'New record removed successfully',
  'pages.uom.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.uom.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.uom.message.noChangesToSync': 'No changes to sync',
  'pages.uom.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.uom.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.uom.message.fetchError': 'Failed to fetch UOMs',
  'pages.uom.refresh.success': 'Data refreshed successfully.',
  'pages.uom.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.uom.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  
  // Site Detail
  'pages.site.title': 'Site Detail',
  'pages.site.column.code': 'Code',
  'pages.site.column.name': 'Name',
  'pages.site.column.defaultLocation': 'Default Location',
  'pages.site.column.isActive': 'Is Active',
  'pages.site.validation.codeRequired': 'Code is required',
  'pages.site.validation.nameRequired': 'Name is required',
  'pages.site.active': 'Active',
  'pages.site.inactive': 'InActive',
  'pages.site.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.site.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.site.message.newRecordRemoved': 'New record removed successfully',
  'pages.site.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.site.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.site.message.noChangesToSync': 'No changes to sync',
  'pages.site.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.site.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.site.message.fetchError': 'Failed to fetch sites',
  'pages.site.refresh.success': 'Data refreshed successfully.',
  'pages.site.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.site.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.site.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.site.refresh.tooltip.normal': 'Refresh data from server',
  
  // Line Detail
  'pages.line.title': 'Line Detail',
  'pages.line.column.code': 'Code',
  'pages.line.column.name': 'Name',
  'pages.line.column.description': 'Description',
  'pages.line.column.worker': 'Worker',
  'pages.line.column.isActive': 'Is Active',
  'pages.line.validation.codeRequired': 'Code is required',
  'pages.line.validation.nameRequired': 'Name is required',
  'pages.line.active': 'Active',
  'pages.line.inactive': 'InActive',
  'pages.line.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.line.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.line.message.newRecordRemoved': 'New record removed successfully',
  'pages.line.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.line.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.line.message.noChangesToSync': 'No changes to sync',
  'pages.line.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.line.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.line.message.fetchError': 'Failed to fetch lines',
  'pages.line.refresh.success': 'Data refreshed successfully.',
  'pages.line.refresh.error': 'Failed to refresh data. Please try again.',
  
  // Machine Detail
  'pages.machine.title': 'Machine Detail',
  'pages.machine.column.code': 'Code',
  'pages.machine.column.name': 'Name',
  'pages.machine.column.description': 'Description',
  'pages.machine.column.serialNo': 'Serial No',
  'pages.machine.column.capacity': 'Capacity',
  'pages.machine.column.capacityUOM': 'Capacity UOM',
  'pages.machine.column.machineDiameter': 'Machine Diameter',
  'pages.machine.column.gauge': 'Gauge',
  'pages.machine.column.batchInDay': 'Batch In Day',
  'pages.machine.column.isActive': 'Is Active',
  'pages.machine.validation.codeRequired': 'Code is required',
  'pages.machine.validation.nameRequired': 'Name is required',
  'pages.machine.active': 'Active',
  'pages.machine.inactive': 'InActive',
  'pages.machine.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.machine.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.machine.message.newRecordRemoved': 'New record removed successfully',
  'pages.machine.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.machine.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.machine.message.noChangesToSync': 'No changes to sync',
  'pages.machine.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.machine.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.machine.message.fetchError': 'Failed to fetch machines',
  'pages.machine.refresh.success': 'Data refreshed successfully.',
  'pages.machine.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.machine.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.machine.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.machine.refresh.tooltip.normal': 'Refresh data from server',
  
  // Supplier Detail
  'pages.supplier.title': 'Supplier Detail',
  'pages.supplier.column.code': 'Code',
  'pages.supplier.column.name': 'Name',
  'pages.supplier.column.supplierTypeId': 'Supplier Type',
  'pages.supplier.column.isActive': 'Is Active',
  'pages.supplier.validation.codeRequired': 'Code is required',
  'pages.supplier.validation.nameRequired': 'Name is required',
  'pages.supplier.active': 'Active',
  'pages.supplier.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.supplier.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.supplier.message.newRecordRemoved': 'New record removed successfully',
  'pages.supplier.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.supplier.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.supplier.message.noChangesToSync': 'No changes to sync',
  'pages.supplier.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.supplier.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.supplier.message.fetchError': 'Failed to fetch suppliers',
  'pages.supplier.refresh.success': 'Data refreshed successfully.',
  'pages.supplier.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.supplier.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.supplier.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.supplier.refresh.tooltip.normal': 'Refresh data from server',
  
  // SupplierType Detail
  'pages.supplierType.title': 'Supplier Type Detail',
  'pages.supplierType.column.code': 'Code',
  'pages.supplierType.column.name': 'Name',
  'pages.supplierType.column.isActive': 'Is Active',
  'pages.supplierType.validation.codeRequired': 'Code is required',
  'pages.supplierType.validation.nameRequired': 'Name is required',
  'pages.supplierType.active': 'Active',
  'pages.supplierType.inactive': 'InActive',
  'pages.supplierType.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.supplierType.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.supplierType.message.newRecordRemoved': 'New record removed successfully',
  'pages.supplierType.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.supplierType.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.supplierType.message.noChangesToSync': 'No changes to sync',
  'pages.supplierType.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.supplierType.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.supplierType.message.fetchError': 'Failed to fetch supplier types',
  'pages.supplierType.refresh.success': 'Data refreshed successfully.',
  'pages.supplierType.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.supplierType.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.supplierType.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.supplierType.refresh.tooltip.normal': 'Refresh data from server',
  
  // Product Detail
  'pages.product.title': 'Product Detail',
  'pages.product.column.code': 'Code',
  'pages.product.column.name': 'Name',
  'pages.product.column.subCategoryId': 'Sub Category',
  'pages.product.column.storingUOMId': 'Storing UOM',
  'pages.product.column.saleUOMId': 'Sale UOM',
  'pages.product.column.purchaseUOMId': 'Purchase UOM',
  'pages.product.column.consumptionUOMId': 'Consumption UOM',
  'pages.product.column.colorId': 'Color',
  'pages.product.column.sizeId': 'Size',
  'pages.product.column.customerId': 'Customer',
  'pages.product.column.supplierId': 'Supplier',
  'pages.product.column.brandId': 'Brand',
  'pages.product.column.minimumQty': 'Min Qty',
  'pages.product.column.maximumQty': 'Max Qty',
  'pages.product.column.buyingPrice': 'Buying Price',
  'pages.product.column.buyingCurrencyId': 'Buying Currency',
  'pages.product.column.description': 'Description',
  'pages.product.column.fabricMaterial': 'Fabric Material',
  'pages.product.column.season': 'Season',
  'pages.product.column.buyerStyleRef': 'Buyer Style Ref',
  'pages.product.column.sam': 'SAM',
  'pages.product.column.isActive': 'Is Active',
  'pages.product.validation.codeRequired': 'Code is required',
  'pages.product.validation.nameRequired': 'Name is required',
  'pages.product.validation.buyingCurrencyIdRequired': 'Buying currency is required',
  'pages.product.validation.storingUOMIdRequired': 'Storing UOM is required',
  'pages.product.active': 'Active',
  'pages.product.inactive': 'InActive',
  'pages.product.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.product.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.product.message.newRecordRemoved': 'New record removed successfully',
  'pages.product.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.product.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.product.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.product.message.noChangesToSync': 'No changes to sync',
  'pages.product.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.product.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.product.message.fetchError': 'Failed to fetch products',
  'pages.product.refresh.success': 'Data refreshed successfully.',
  'pages.product.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.product.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.product.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.product.refresh.tooltip.normal': 'Refresh data from server',
  'pages.product.column.gsm': 'GSM',
  
  // Holiday Detail
  'pages.holiday.title': 'Holiday Detail',
  'pages.holiday.column.code': 'Code',
  'pages.holiday.column.name': 'Name',
  'pages.holiday.column.date': 'Date',
  'pages.holiday.column.isActive': 'Is Active',
  'pages.holiday.validation.codeRequired': 'Code is required',
  'pages.holiday.validation.nameRequired': 'Name is required',
  'pages.holiday.active': 'Active',
  'pages.holiday.inactive': 'InActive',
  'pages.holiday.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.holiday.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.holiday.message.newRecordRemoved': 'New record removed successfully',
  'pages.holiday.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.holiday.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.holiday.message.noChangesToSync': 'No changes to sync',
  'pages.holiday.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.holiday.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.holiday.message.fetchError': 'Failed to fetch holidays',
  'pages.holiday.refresh.success': 'Data refreshed successfully.',
  'pages.holiday.refresh.error': 'Failed to refresh data. Please try again.',
  
  // Port Detail
  'pages.port.title': 'Port Detail',
  'pages.port.column.code': 'Code',
  'pages.port.column.name': 'Name',
  'pages.port.column.countryId': 'Country',
  'pages.port.column.portOfLoading': 'Port of Loading',
  'pages.port.column.portOfDischarge': 'Port of Discharge',
  'pages.port.column.portOfReceiptByPreCarrier': 'Port of Receipt by Pre-Carrier',
  'pages.port.column.isActive': 'Is Active',
  'pages.port.validation.codeRequired': 'Code is required',
  'pages.port.validation.nameRequired': 'Name is required',
  'pages.port.active': 'Active',
  'pages.port.inactive': 'InActive',
  'pages.port.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.port.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.port.message.newRecordRemoved': 'New record removed successfully',
  'pages.port.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.port.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.port.message.noChangesToSync': 'No changes to sync',
  'pages.port.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.port.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.port.message.fetchError': 'Failed to fetch ports',
  'pages.port.refresh.success': 'Data refreshed successfully.',
  'pages.port.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.port.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.port.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.port.refresh.tooltip.normal': 'Refresh data from server',
  
  // ShipmentTerm Detail
  'pages.shipmentTerm.title': 'Shipment Term Detail',
  'pages.shipmentTerm.column.code': 'Code',
  'pages.shipmentTerm.column.name': 'Name',
  'pages.shipmentTerm.column.isActive': 'Is Active',
  'pages.shipmentTerm.validation.codeRequired': 'Code is required',
  'pages.shipmentTerm.validation.nameRequired': 'Name is required',
  'pages.shipmentTerm.active': 'Active',
  'pages.shipmentTerm.inactive': 'InActive',
  'pages.shipmentTerm.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.shipmentTerm.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.shipmentTerm.message.newRecordRemoved': 'New record removed successfully',
  'pages.shipmentTerm.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.shipmentTerm.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.shipmentTerm.message.noChangesToSync': 'No changes to sync',
  'pages.shipmentTerm.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.shipmentTerm.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.shipmentTerm.message.fetchError': 'Failed to fetch shipment terms',
  'pages.shipmentTerm.refresh.success': 'Data refreshed successfully.',
  'pages.shipmentTerm.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.shipmentTerm.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.shipmentTerm.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.shipmentTerm.refresh.tooltip.normal': 'Refresh data from server',
  
  // PaymentTerm Detail
  'pages.paymentTerm.title': 'Payment Term Detail',
  'pages.paymentTerm.column.code': 'Code',
  'pages.paymentTerm.column.name': 'Name',
  'pages.paymentTerm.column.creditDays': 'Credit Days',
  'pages.paymentTerm.column.isActive': 'Is Active',
  'pages.paymentTerm.validation.codeRequired': 'Code is required',
  'pages.paymentTerm.validation.nameRequired': 'Name is required',
  'pages.paymentTerm.active': 'Active',
  'pages.paymentTerm.inactive': 'InActive',
  'pages.paymentTerm.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.paymentTerm.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.paymentTerm.message.newRecordRemoved': 'New record removed successfully',
  'pages.paymentTerm.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.paymentTerm.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.paymentTerm.message.noChangesToSync': 'No changes to sync',
  'pages.paymentTerm.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.paymentTerm.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.paymentTerm.message.fetchError': 'Failed to fetch payment terms',
  'pages.paymentTerm.refresh.success': 'Data refreshed successfully.',
  'pages.paymentTerm.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.paymentTerm.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.paymentTerm.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.paymentTerm.refresh.tooltip.normal': 'Refresh data from server',
  
  'pages.organizationDetail.title': 'Organization Details',
  'pages.organizationDetail.createForm.title': 'Add Organization Detail',
  'pages.organizationDetail.updateForm.title': 'Edit Organization Detail',
  'pages.organizationDetail.form.name': 'Name',
  'pages.organizationDetail.form.code': 'Code',
  'pages.organizationDetail.form.integrationId': 'Integration ID',
  'pages.organizationDetail.form.organization': 'Organization',
  'pages.organizationDetail.form.parentDetail': 'Parent Detail',
  'pages.organizationDetail.form.name.required': 'Please enter organization detail name',
  'pages.organizationDetail.form.code.required': 'Please enter organization detail code',
  'pages.organizationDetail.form.organization.required': 'Please select an organization',
  'pages.organizationDetail.button.addNew': 'Add New',
  'pages.organizationDetail.button.refresh': 'Refresh',
  'pages.organizationDetail.button.save': 'Save',
  'pages.organizationDetail.button.cancel': 'Cancel',
  'pages.organizationDetail.message.createSuccess': 'Organization detail created successfully',
  'pages.organizationDetail.message.updateSuccess': 'Organization detail updated successfully',
  'pages.organizationDetail.message.deleteSuccess': 'Organization detail deleted successfully',
  'pages.organizationDetail.message.createError': 'Failed to save organization detail',
  'pages.organizationDetail.message.deleteError': 'Failed to delete organization detail',
  'pages.organizationDetail.message.fetchError': 'Failed to fetch organization details',
  'pages.organizationDetail.message.nestedDataError': 'Failed to fetch nested data',
  'pages.organizationDetail.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.organizationDetail.delete.yes': 'Yes',
  'pages.organizationDetail.delete.no': 'No',
  'pages.organizationDetail.button.edit': 'Edit',
  'pages.organizationDetail.button.delete': 'Delete',
  'pages.organizationDetail.placeholder.name': 'Enter organization detail name',
  'pages.organizationDetail.placeholder.code': 'Enter organization detail code',
  'pages.organizationDetail.placeholder.integrationId': 'Enter integration ID (optional)',
  'pages.organizationDetail.placeholder.organization': 'Select an organization',
  'pages.organizationDetail.placeholder.parentDetail': 'Select parent detail (optional)',
  'pages.organizationDetail.placeholder.organizationFirst': 'Select an organization first',
  'pages.organizationDetail.column.code': 'Code',
  'pages.organizationDetail.column.name': 'Name',
  'pages.organizationDetail.column.organization': 'Organization',
  'pages.organizationDetail.column.level': 'Level',
  'pages.organizationDetail.column.parent': 'Parent',
  'pages.organizationDetail.column.integrationId': 'Integration ID',
  'pages.organizationDetail.column.isActive': 'Is Active',
  'pages.organizationDetail.column.actions': 'Actions',
  'pages.organizationDetail.text.unknown': 'Unknown',
  'pages.organizationDetail.code': 'Code',
  'pages.organizationDetail.name': 'Name',
  'pages.organizationDetail.parent': 'Parent Organization',
  'pages.organizationDetail.employee': 'Employee',
  'pages.organizationDetail.employee.placeholder': 'Select employee',
  'pages.organizationDetail.add': 'Add Organization Detail',
  'pages.organizationDetail.remove': 'Remove',
  'pages.organizationDetail.parent.placeholder': 'Select parent organization for detail',
  'pages.organizationDetail.placeholder.selectOrganization': 'Select Organization',
  'pages.organizationDetail.validation.organizationRequired': 'Organization is required',
  'pages.organizationDetail.validation.codeRequired': 'Code is required',
  'pages.organizationDetail.validation.nameRequired': 'Name is required',
  'pages.organizationDetail.message.newNestedRecordRemoved': 'New nested record removed successfully',
  'pages.organizationDetail.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.organizationDetail.message.failedToFetchOrganizationOptions': 'Failed to fetch organization options',
  'pages.organizationDetail.message.organizationCreatedSuccessfully': 'Organization created successfully',
  'pages.organizationDetail.message.failedToCreateOrganization': 'Failed to create organization',
  'pages.organizationDetail.message.newRecordRemoved': 'New record removed successfully',
  'pages.organizationDetail.message.missingRequiredFields': 'Missing required fields in main table rows: {errorDetails}',
  'pages.organizationDetail.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.organizationDetail.message.noChangesToSync': 'No changes to sync',
  'pages.organizationDetail.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.organizationDetail.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.organizationDetail.message.newRowAddedSuccessfully': 'New row added successfully! Start typing to fill in the details.',
  'pages.organizationDetail.message.childRecordCreated': 'Child record created. You can edit it in the nested table below.',
  'pages.organizationDetail.tooltip.addChildRecord': 'Add child record',
  'pages.organizationDetail.tooltip.createChildOrganization': 'Create child organization',
  'pages.organizationDetail.modal.createChildOrganization': 'Create Child Organization',
  'pages.organizationDetail.modal.createNewOrganization': 'Create New Organization',
  'pages.organizationDetail.form.organizationName': 'Organization Name',
  'pages.organizationDetail.form.organizationCode': 'Organization Code',
  'pages.organizationDetail.form.organizationLevel': 'Organization Level',
  'pages.organizationDetail.form.parentOrganization': 'Parent Organization',
  'pages.organizationDetail.form.organizationName.placeholder': 'Enter organization name',
  'pages.organizationDetail.form.organizationCode.placeholder': 'Enter organization code',
  'pages.organizationDetail.form.organizationLevel.placeholder': 'Select organization level',
  'pages.organizationDetail.form.parentOrganization.placeholder': 'Select parent organization',
  'pages.organizationDetail.form.organizationName.required': 'Please input organization name!',
  'pages.organizationDetail.form.organizationCode.required': 'Please input organization code!',
  'pages.organizationDetail.form.organizationLevel.required': 'Please select organization level!',
  'pages.organizationDetail.form.organizationName.minMax': 'Name must be between 2 and 50 characters.',
  'pages.organizationDetail.form.organizationCode.pattern': 'Code can only contain uppercase letters and numbers.',
  'pages.organizationDetail.form.organizationCode.minMax': 'Code must be between 2 and 10 characters.',
  'pages.organizationDetail.button.yes': 'Yes',
  'pages.organizationDetail.button.no': 'No',
  'pages.organizationDetail.button.create': 'Create',
  'pages.organizationDetail.dropdown.createNewOrganization': 'Create New Organization',
  'pages.organizationDetail.validation.name.minMax': 'Name must be between 2 and 50 characters.',
  'pages.organizationDetail.validation.code.pattern': 'Code can only contain uppercase letters and numbers.',
  'pages.organizationDetail.validation.code.minMax': 'Code must be between 2 and 10 characters.',
  'pages.organizationDetail.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.organizationDetail.refresh.success': 'Data refreshed successfully.',
  'pages.organizationDetail.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.organizationDetail.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.organizationDetail.refresh.tooltip.normal': 'Refresh data from server',
  'pages.organization.chart.title': 'Organization Details Chart',
  'pages.organization.chart.subtitle': 'Organization Details Overview',
  'pages.organization.chart.description': 'Total records:',
  'pages.organization.chart.data.title': 'Organization Details Tree View',
  'pages.organization.chart.total': 'Total',
  'pages.organization.chart.withParent': 'With Parent',
  'pages.organization.chart.withoutParent': 'Without Parent',
  'pages.organization.chart.showing': 'Showing first 10 records of',
  'pages.organization.chart.noData': 'No organization details data available',
  'pages.organization.chart.level': 'Level',
  'pages.costCategory.code': 'Code',
  'pages.costCategory.name': 'Name',
  'pages.costCategory.isActive': 'Status',
  'pages.costCategory.updatedAt': 'Updated At',
  'pages.costCategory.createdAt': 'Created At',
  'pages.costCategory.create': 'Create',
  'pages.costCategory.update': 'Update',
  'pages.costCategory.details': 'Cost Category Details',
  'pages.costCategory.delete.confirm': 'Are you sure you want to delete?',
  'pages.costCategory.delete.ok': 'Delete',
  'pages.costCategory.delete.cancel': 'Cancel',
  'pages.costCategory.save': 'Save',
  'pages.costCategory.cancel': 'Cancel',
  'pages.costCategory.close': 'Close',
  'pages.costCategory.code.required': 'Code is required',
  'pages.costCategory.name.required': 'Name is required',
  'pages.costItem.code': 'Code',
  'pages.costItem.name': 'Name',
  'pages.costItem.costCategory': 'Cost Category',
  'pages.costItem.costCategory.search.placeholder': 'Select cost category',
  'pages.costItem.isActive': 'Status',
  'pages.costItem.updatedAt': 'Updated At',
  'pages.costItem.createdAt': 'Created At',
  'pages.costItem.create': 'Create',
  'pages.costItem.update': 'Update',
  'pages.costItem.details': 'Cost Item Details',
  'pages.costItem.delete.confirm': 'Are you sure you want to delete?',
  'pages.costItem.delete.ok': 'Delete',
  'pages.costItem.delete.cancel': 'Cancel',
  'pages.costItem.save': 'Save',
  'pages.costItem.cancel': 'Cancel',
  'pages.costItem.close': 'Close',
  'pages.costItem.code.required': 'Code is required',
  'pages.costItem.name.required': 'Name is required',
  'pages.costItem.costCategoryId.required': 'Please select a cost category',
  'pages.employee.code': 'Code',
  'pages.employee.name': 'Name',
  'pages.employee.organizationDetail': 'Organization Detail',
  'pages.employee.organizationDetail.search.placeholder': 'Select organization detail',
  'pages.employee.isActive': 'Status',
  'pages.employee.updatedAt': 'Updated At',
  'pages.employee.createdAt': 'Created At',
  'pages.employee.create': 'Create',
  'pages.employee.update': 'Update',
  'pages.employee.details': 'Employee Details',
  'pages.employee.delete.confirm': 'Are you sure you want to delete?',
  'pages.employee.delete.ok': 'Delete',
  'pages.employee.delete.cancel': 'Cancel',
  'pages.employee.save': 'Save',
  'pages.employee.cancel': 'Cancel',
  'pages.employee.close': 'Close',
  'pages.employee.code.required': 'Code is required',
  'pages.employee.name.required': 'Name is required',
  'pages.employee.title': 'Employee Detail',
  'pages.employee.column.code': 'Code',
  'pages.employee.column.name': 'Name',
  'pages.employee.column.isActive': 'Is Active',
  'pages.employee.column.organization': 'Organization',
  'pages.employee.column.jobPosition': 'Job Position',
  'pages.employee.column.manager': 'Manager',
  'pages.employee.column.personInChargeType': 'Person In Charge',
  'pages.employee.personInCharge.incharge': 'Incharge',
  'pages.employee.personInCharge.all': 'All',
  'pages.employee.validation.codeRequired': 'Code is required',
  'pages.employee.validation.nameRequired': 'Name is required',
  'pages.employee.message.fetchError': 'Failed to fetch employees',
  'pages.employee.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.employee.message.noChangesToSync': 'No changes to sync',
  'pages.employee.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.employee.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.employee.message.newRecordRemoved': 'New record removed successfully',
  'pages.employee.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.employee.active': 'Active',
  'pages.employee.inactive': 'InActive',
  'pages.employee.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.employee.refresh.success': 'Data refreshed successfully.',
  'pages.employee.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.employee.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.employee.refresh.tooltip.normal': 'Refresh data from server',
  'pages.employee.delete.confirm2': 'Are you sure you want to delete this record?',
  'pages.costRequest.code': 'Code',
  'pages.costRequest.type': 'Type',
  'pages.costRequest.type.manual': 'Manual',
  'pages.costRequest.type.synced': 'Synced',
  'pages.costRequest.date': 'Date',
  'pages.costRequest.costCategory': 'Cost Category',
  'pages.costRequest.costItem': 'Cost Item',
  'pages.costRequest.organizationDetail': 'Requesting Department',
  'pages.costRequest.description': 'Description',
  'pages.costRequest.reason': 'Reason',
  'pages.costRequest.totalAmount': 'Total Amount',
  'pages.costRequest.status': 'Status',
  'pages.costRequest.status.draft': 'Draft',
  'pages.costRequest.status.pending': 'Pending',
  'pages.costRequest.status.approved': 'Approved',
  'pages.costRequest.status.rejected': 'Rejected',
  'pages.costRequest.status.canceled': 'Canceled',
  'pages.costRequest.updatedAt': 'Updated At',
  'pages.costRequest.createdAt': 'Created At',
  'pages.costRequest.view.title': 'View Cost Request',
  'pages.costRequest.create.title': 'Create Cost Request',
  'pages.costRequest.update.title': 'Update Cost Request',
  'pages.costRequest.approve': 'Approve',
  'pages.costRequest.reject': 'Reject',
  'pages.costRequest.reject.reason': 'Rejection Reason',
  'pages.costRequest.reject.confirm': 'Confirm',
  'pages.costRequest.reject.cancel': 'Cancel',
  'pages.costRequest.reject.reason.placeholder': 'Enter rejection reason (required)...',
  'pages.costRequest.cancel': 'Cancel',
  'pages.costRequest.cancel.reason': 'Cancellation Reason',
  'pages.costRequest.cancel.confirm': 'Confirm',
  'pages.costRequest.cancel.cancel': 'Cancel',
  'pages.costRequest.cancel.reason.required': 'Please enter the cancellation reason',
  'pages.costRequest.cancel.reason.placeholder': 'Enter cancellation reason (required)...',
  'pages.costRequest.bulkReject.title': 'Bulk Reject Cost Requests',
  'pages.costRequest.bulkReject.description': 'Are you sure you want to bulk reject these cost requests?',
  'pages.costRequest.bulkReject.reason': 'Reason for bulk reject:',
  'pages.costRequest.bulkReject.reasonPlaceholder': 'Enter reason for bulk reject',
  'pages.costRequest.bulkCancel.title': 'Bulk Cancel Cost Requests',
  'pages.costRequest.bulkCancel.description': 'Are you sure you want to bulk cancel these cost requests?',
  'pages.costRequest.bulkCancel.reason': 'Reason for bulk cancel:',
  'pages.costRequest.bulkCancel.reasonPlaceholder': 'Enter reason for bulk cancel',
  'pages.costRequest.code.placeholder': 'Enter code',
  'pages.costRequest.type.placeholder': 'Select type',
  'pages.costRequest.date.placeholder': 'Select date',
  'pages.costRequest.costItem.placeholder': 'Select cost item',
  'pages.costRequest.organizationDetail.placeholder': 'Select requesting department',
  'pages.costRequest.costItem.search.placeholder': 'Select cost item',
  'pages.costRequest.organizationDetail.search.placeholder': 'Select requesting department',
  'pages.costRequest.description.placeholder': 'Enter description',
  'pages.costRequest.totalAmount.placeholder': 'Total amount will be calculated automatically',
  'pages.costRequest.details.add': 'Add Detail',
  'pages.costRequest.details.delete': 'Delete Detail',
  'pages.costRequest.detail.organizationDetail': 'Organization Detail',
  'pages.costRequest.detail.organizationDetail.placeholder': 'Select organization detail',
  'pages.costRequest.detail.amount': 'Amount',
  'pages.costRequest.detail.amount.placeholder': 'Enter amount',
  'pages.costRequest.detail.description': 'Description',
  'pages.costRequest.detail.description.placeholder': 'Enter description',
  'pages.reports.viewMode': 'View Mode',
  'pages.reports.viewMode.yearly': 'Yearly',
  'pages.reports.viewMode.quarterly': 'Quarterly',
  'pages.reports.viewMode.monthly': 'Monthly',
  'pages.reports.dateRange': 'Date Range',
  'pages.reports.dateRange.start': 'Start Date',
  'pages.reports.dateRange.end': 'End Date',
  'pages.reports.expand': 'Expand',
  'pages.reports.collapse': 'Collapse',
  'pages.reports.expandAll': 'Expand All',
  'pages.reports.collapseAll': 'Collapse All',
  'pages.reports.export': 'Export',
  'pages.reports.exportToExcel': 'Export Excel',

  // Address Detail
  'pages.addressDetail.title': 'Address Detail',
  'pages.addressDetail.filter.address': 'Address',
  'pages.addressDetail.placeholder.selectAddress': 'Select address',
  'pages.addressDetail.column.address': 'Address',
  'pages.addressDetail.column.code': 'Code',
  'pages.addressDetail.column.name': 'Name',
  'pages.addressDetail.column.integrationId': 'Integration Id',
  'pages.addressDetail.column.zipCode': 'Zip Code',
  'pages.addressDetail.column.longitude': 'Longitude',
  'pages.addressDetail.column.latitude': 'Latitude',
  'pages.addressDetail.validation.addressRequired': 'Address is required',
  'pages.addressDetail.validation.codeRequired': 'Code is required',
  'pages.addressDetail.validation.nameRequired': 'Name is required',
  'pages.addressDetail.message.fetchError': 'Failed to fetch address details',
  'pages.addressDetail.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.addressDetail.refresh.success': 'Data refreshed successfully.',
  'pages.addressDetail.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.addressDetail.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.addressDetail.refresh.tooltip.normal': 'Refresh data from server',

  // Operation Library Detail
  'pages.operationLibraryDetail.title': 'Operation Library Detail',
  'pages.operationLibraryDetail.filter.operationLibrary': 'Operation Library',
  'pages.operationLibraryDetail.placeholder.selectOperationLibrary': 'Select operation library',
  'pages.operationLibraryDetail.column.operationLibrary': 'Operation Library',
  'pages.operationLibraryDetail.column.code': 'Code',
  'pages.operationLibraryDetail.column.name': 'Name',
  'pages.operationLibraryDetail.column.subCategories': 'Sub Categories',
  'pages.operationLibraryDetail.column.machineType': 'Machine Type',
  'pages.operationLibraryDetail.column.integrationId': 'Integration Id',
  'pages.operationLibraryDetail.validation.operationLibraryRequired': 'Operation library is required',
  'pages.operationLibraryDetail.validation.codeRequired': 'Code is required',
  'pages.operationLibraryDetail.validation.nameRequired': 'Name is required',
  'pages.operationLibraryDetail.message.fetchError': 'Failed to fetch operation library details',
  'pages.operationLibraryDetail.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.operationLibraryDetail.refresh.success': 'Data refreshed successfully.',
  'pages.operationLibraryDetail.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.operationLibraryDetail.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.operationLibraryDetail.refresh.tooltip.normal': 'Refresh data from server',


  // Account Group Detail
  'pages.accountGroup.title': 'Account Group Detail',
  'pages.accountGroup.column.code': 'Code',
  'pages.accountGroup.column.name': 'Name',
  'pages.accountGroup.column.isActive': 'Is Active',
  'pages.accountGroup.validation.codeRequired': 'Code is required',
  'pages.accountGroup.validation.nameRequired': 'Name is required',
  'pages.accountGroup.message.fetchError': 'Failed to fetch account groups',
  'pages.accountGroup.active': 'Active',
  'pages.accountGroup.inactive': 'InActive',
  'pages.accountGroup.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.accountGroup.refresh.success': 'Data refreshed successfully.',
  'pages.accountGroup.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.accountGroup.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.accountGroup.refresh.tooltip.normal': 'Refresh data from server',
  'pages.accountGroup.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.common.noPermission': 'You do not have permission to perform this action',

  // Color Detail
  'pages.color.title': 'Color Detail',
  'pages.color.column.code': 'Code',
  'pages.color.column.name': 'Name',
  'pages.color.column.type': 'Type',
  'pages.color.column.value': 'Value',
  'pages.color.column.description': 'Description',
  'pages.color.column.isActive': 'Is Active',
  'pages.color.validation.codeRequired': 'Code is required',
  'pages.color.validation.nameRequired': 'Name is required',
  'pages.color.validation.typeRequired': 'Type is required',
  'pages.color.validation.valueRequired': 'Value is required',
  'pages.color.message.fetchError': 'Failed to fetch colors',
  'pages.color.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.color.message.noChangesToSync': 'No changes to sync',
  'pages.color.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.color.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.color.message.newRecordRemoved': 'New record removed successfully',
  'pages.color.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.color.active': 'Active',
  'pages.color.inactive': 'InActive',
  'pages.color.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.color.refresh.success': 'Data refreshed successfully.',
  'pages.color.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.color.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.color.refresh.tooltip.normal': 'Refresh data from server',
  'pages.color.delete.confirm': 'Are you sure you want to delete this record?',

  // Currency Detail
  'pages.currency.title': 'Currency Detail',
  'pages.currency.column.code': 'Code',
  'pages.currency.column.name': 'Name',
  'pages.currency.column.decimalPlaces': 'Decimal Places',
  'pages.currency.column.isActive': 'Is Active',
  'pages.currency.validation.codeRequired': 'Code is required',
  'pages.currency.validation.nameRequired': 'Name is required',
  'pages.currency.message.fetchError': 'Failed to fetch currencies',
  'pages.currency.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.currency.message.noChangesToSync': 'No changes to sync',
  'pages.currency.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.currency.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.currency.message.newRecordRemoved': 'New record removed successfully',
  'pages.currency.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.currency.active': 'Active',
  'pages.currency.inactive': 'InActive',
  'pages.currency.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.currency.refresh.success': 'Data refreshed successfully.',
  'pages.currency.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.currency.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.currency.refresh.tooltip.normal': 'Refresh data from server',
  'pages.currency.delete.confirm': 'Are you sure you want to delete this record?',

  // Customer Detail
  'pages.customer.title': 'Customer Detail',
  'pages.customer.column.code': 'Code',
  'pages.customer.column.name': 'Name',
  'pages.customer.column.isActive': 'Is Active',
  'pages.customer.validation.codeRequired': 'Code is required',
  'pages.customer.validation.nameRequired': 'Name is required',
  'pages.customer.message.fetchError': 'Failed to fetch customers',
  'pages.customer.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.customer.message.noChangesToSync': 'No changes to sync',
  'pages.customer.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.customer.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.customer.message.newRecordRemoved': 'New record removed successfully',
  'pages.customer.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.customer.active': 'Active',
  'pages.customer.inactive': 'InActive',
  'pages.customer.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.customer.refresh.success': 'Data refreshed successfully.',
  'pages.customer.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.customer.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.customer.refresh.tooltip.normal': 'Refresh data from server',
  'pages.customer.delete.confirm': 'Are you sure you want to delete this record?',

  // Customer Type Detail
  'pages.customerType.title': 'Customer Type Detail',
  'pages.customerType.column.code': 'Code',
  'pages.customerType.column.name': 'Name',
  'pages.customerType.column.isActive': 'Is Active',
  'pages.customerType.validation.codeRequired': 'Code is required',
  'pages.customerType.validation.nameRequired': 'Name is required',
  'pages.customerType.message.fetchError': 'Failed to fetch customer types',
  'pages.customerType.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.customerType.message.noChangesToSync': 'No changes to sync',
  'pages.customerType.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.customerType.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.customerType.message.newRecordRemoved': 'New record removed successfully',
  'pages.customerType.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.customerType.active': 'Active',
  'pages.customerType.inactive': 'InActive',
  'pages.customerType.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.customerType.refresh.success': 'Data refreshed successfully.',
  'pages.customerType.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.customerType.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.customerType.refresh.tooltip.normal': 'Refresh data from server',
  'pages.customerType.delete.confirm': 'Are you sure you want to delete this record?',

  // Address Detail
  'pages.address.title': 'Address Detail',
  'pages.address.column.code': 'Code',
  'pages.address.column.name': 'Name',
  'pages.address.column.isActive': 'Is Active',
  'pages.address.validation.codeRequired': 'Code is required',
  'pages.address.validation.nameRequired': 'Name is required',
  'pages.address.message.fetchError': 'Failed to fetch addresses',
  'pages.address.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.address.message.noChangesToSync': 'No changes to sync',
  'pages.address.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.address.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.address.message.newRecordRemoved': 'New record removed successfully',
  'pages.address.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.address.active': 'Active',
  'pages.address.inactive': 'InActive',
  'pages.address.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.address.refresh.success': 'Data refreshed successfully.',
  'pages.address.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.address.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.address.refresh.tooltip.normal': 'Refresh data from server',
  'pages.address.delete.confirm': 'Are you sure you want to delete this record?',

  // Calendar Customize Detail
  'pages.calendarCustomize.title': 'Calendar Customize Detail',
  'pages.calendarCustomize.column.code': 'Code',
  'pages.calendarCustomize.column.name': 'Name',
  'pages.calendarCustomize.column.fromDate': 'From Date',
  'pages.calendarCustomize.column.toDate': 'To Date',
  'pages.calendarCustomize.column.isActive': 'Is Active',
  'pages.calendarCustomize.validation.codeRequired': 'Code is required',
  'pages.calendarCustomize.validation.nameRequired': 'Name is required',
  'pages.calendarCustomize.validation.fromDateRequired': 'From Date is required',
  'pages.calendarCustomize.validation.toDateRequired': 'To Date is required',
  'pages.calendarCustomize.message.fetchError': 'Failed to fetch calendar customizes',
  'pages.calendarCustomize.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.calendarCustomize.message.noChangesToSync': 'No changes to sync',
  'pages.calendarCustomize.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.calendarCustomize.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.calendarCustomize.message.newRecordRemoved': 'New record removed successfully',
  'pages.calendarCustomize.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.calendarCustomize.active': 'Active',
  'pages.calendarCustomize.inactive': 'InActive',
  'pages.calendarCustomize.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.calendarCustomize.refresh.success': 'Data refreshed successfully.',
  'pages.calendarCustomize.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.calendarCustomize.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.calendarCustomize.refresh.tooltip.normal': 'Refresh data from server',
  'pages.calendarCustomize.delete.confirm': 'Are you sure you want to delete this record?',

  // Calendar Detail
  'pages.calendar.title': 'Calendar Detail',
  'pages.calendar.column.code': 'Code',
  'pages.calendar.column.name': 'Name',
  'pages.calendar.column.isActive': 'Is Active',
  'pages.calendar.validation.codeRequired': 'Code is required',
  'pages.calendar.validation.nameRequired': 'Name is required',
  'pages.calendar.message.fetchError': 'Failed to fetch calendars',
  'pages.calendar.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.calendar.message.noChangesToSync': 'No changes to sync',
  'pages.calendar.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.calendar.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.calendar.message.newRecordRemoved': 'New record removed successfully',
  'pages.calendar.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.calendar.active': 'Active',
  'pages.calendar.inactive': 'InActive',
  'pages.calendar.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.calendar.refresh.success': 'Data refreshed successfully.',
  'pages.calendar.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.calendar.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.calendar.refresh.tooltip.normal': 'Refresh data from server',
  'pages.calendar.delete.confirm': 'Are you sure you want to delete this record?',

  // Delivery Term Detail
  'pages.deliveryTerm.title': 'Delivery Term Detail',
  'pages.deliveryTerm.column.code': 'Code',
  'pages.deliveryTerm.column.name': 'Name',
  'pages.deliveryTerm.column.isActive': 'Is Active',
  'pages.deliveryTerm.validation.codeRequired': 'Code is required',
  'pages.deliveryTerm.validation.nameRequired': 'Name is required',
  'pages.deliveryTerm.message.fetchError': 'Failed to fetch delivery terms',
  'pages.deliveryTerm.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.deliveryTerm.message.noChangesToSync': 'No changes to sync',
  'pages.deliveryTerm.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.deliveryTerm.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.deliveryTerm.message.newRecordRemoved': 'New record removed successfully',
  'pages.deliveryTerm.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.deliveryTerm.active': 'Active',
  'pages.deliveryTerm.inactive': 'InActive',
  'pages.deliveryTerm.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.deliveryTerm.refresh.success': 'Data refreshed successfully.',
  'pages.deliveryTerm.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.deliveryTerm.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.deliveryTerm.refresh.tooltip.normal': 'Refresh data from server',
  'pages.deliveryTerm.delete.confirm': 'Are you sure you want to delete this record?',

  // Brand Detail
  'pages.brand.title': 'Brand Detail',
  'pages.brand.column.code': 'Code',
  'pages.brand.column.name': 'Name',
  'pages.brand.column.isActive': 'Is Active',
  'pages.brand.validation.codeRequired': 'Code is required',
  'pages.brand.validation.nameRequired': 'Name is required',
  'pages.brand.message.fetchError': 'Failed to fetch brands',
  'pages.brand.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.brand.message.noChangesToSync': 'No changes to sync',
  'pages.brand.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.brand.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.brand.message.newRecordRemoved': 'New record removed successfully',
  'pages.brand.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.brand.active': 'Active',
  'pages.brand.inactive': 'InActive',
  'pages.brand.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.brand.refresh.success': 'Data refreshed successfully.',
  'pages.brand.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.brand.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.brand.refresh.tooltip.normal': 'Refresh data from server',
  'pages.brand.delete.confirm': 'Are you sure you want to delete this record?',
  
  // QueryFilter Labels
  'pages.queryFilter.label.code': 'Code',
  'pages.queryFilter.label.name': 'Name',
  'pages.queryFilter.label.integrationId': 'Integration Id',
  'pages.queryFilter.label.zipCode': 'Zip Code',
  'pages.queryFilter.label.isActive': 'Is Active',
  'pages.queryFilter.label.organization': 'Organization',
  
  // Category Detail
  'pages.category.title': 'Category Detail',
  'pages.category.column.code': 'Code',
  'pages.category.column.name': 'Name',
  'pages.category.column.isActive': 'Is Active',
  'pages.category.validation.codeRequired': 'Code is required',
  'pages.category.validation.nameRequired': 'Name is required',
  'pages.category.message.fetchError': 'Failed to fetch categories',
  'pages.category.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.category.message.noChangesToSync': 'No changes to sync',
  'pages.category.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.category.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.category.message.newRecordRemoved': 'New record removed successfully',
  'pages.category.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.category.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.category.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.category.active': 'Active',
  'pages.category.inactive': 'InActive',
  'pages.category.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.category.refresh.success': 'Data refreshed successfully.',
  'pages.category.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.category.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.category.refresh.tooltip.normal': 'Refresh data from server',
  'pages.category.delete.confirm': 'Are you sure you want to delete this record?',

  // ProductCategory Detail
  'pages.productCategory.title': 'Product Category Detail',
  'pages.productCategory.column.code': 'Code',
  'pages.productCategory.column.name': 'Name',
  'pages.productCategory.column.isActive': 'Is Active',
  'pages.productCategory.validation.codeRequired': 'Code is required',
  'pages.productCategory.validation.nameRequired': 'Name is required',
  'pages.productCategory.message.fetchError': 'Failed to fetch product categories',
  'pages.productCategory.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.productCategory.message.noChangesToSync': 'No changes to sync',
  'pages.productCategory.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.productCategory.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.productCategory.message.newRecordRemoved': 'New record removed successfully',
  'pages.productCategory.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.productCategory.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.productCategory.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.productCategory.active': 'Active',
  'pages.productCategory.inactive': 'InActive',
  'pages.productCategory.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.productCategory.refresh.success': 'Data refreshed successfully.',
  'pages.productCategory.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.productCategory.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.productCategory.refresh.tooltip.normal': 'Refresh data from server',
  'pages.productCategory.delete.confirm': 'Are you sure you want to delete this category?',
  'pages.productCategory.delete.description':
    'Deletion will be blocked if this category is already assigned to a product, BOM, or routing.',
  'pages.productCategory.column.integrationIds': 'Integration IDs',
  'pages.productCategory.validation.parentRequired': 'Parent is required for level > 1',

  // ProductGroup Detail
  'pages.productGroup.title': 'Product Group Detail',
  'pages.productGroup.column.code': 'Code',
  'pages.productGroup.column.name': 'Name',
  'pages.productGroup.column.isActive': 'Is Active',
  'pages.productGroup.validation.codeRequired': 'Code is required',
  'pages.productGroup.validation.nameRequired': 'Name is required',
  'pages.productGroup.message.fetchError': 'Failed to fetch product groups',
  'pages.productGroup.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.productGroup.message.noChangesToSync': 'No changes to sync',
  'pages.productGroup.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.productGroup.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.productGroup.message.newRecordRemoved': 'New record removed successfully',
  'pages.productGroup.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.productGroup.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.productGroup.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.productGroup.active': 'Active',
  'pages.productGroup.inactive': 'InActive',
  'pages.productGroup.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.productGroup.refresh.success': 'Data refreshed successfully.',
  'pages.productGroup.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.productGroup.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.productGroup.refresh.tooltip.normal': 'Refresh data from server',
  'pages.productGroup.delete.confirm': 'Are you sure you want to delete this record?',

  // SubCategory Detail
  'pages.subCategory.title': 'Sub Category Detail',
  'pages.subCategory.column.code': 'Code',
  'pages.subCategory.column.name': 'Name',
  'pages.subCategory.column.isActive': 'Is Active',
  'pages.subCategory.validation.codeRequired': 'Code is required',
  'pages.subCategory.validation.nameRequired': 'Name is required',
  'pages.subCategory.message.fetchError': 'Failed to fetch sub categories',
  'pages.subCategory.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.subCategory.message.noChangesToSync': 'No changes to sync',
  'pages.subCategory.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.subCategory.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.subCategory.message.newRecordRemoved': 'New record removed successfully',
  'pages.subCategory.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.subCategory.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.subCategory.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.subCategory.active': 'Active',
  'pages.subCategory.inactive': 'InActive',
  'pages.subCategory.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.subCategory.refresh.success': 'Data refreshed successfully.',
  'pages.subCategory.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.subCategory.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.subCategory.refresh.tooltip.normal': 'Refresh data from server',
  'pages.subCategory.delete.confirm': 'Are you sure you want to delete this record?',

  // Component Detail
  'pages.component.title': 'Component Detail',
  'pages.component.column.code': 'Code',
  'pages.component.column.name': 'Name',
  'pages.component.column.componentGroupId': 'Component Group',
  'pages.component.column.componentGroupName': 'Component Group Name',
  'pages.component.column.uomId': 'UOM',
  'pages.component.column.consumptionQuantity': 'Consumption Quantity',
  'pages.component.column.isActive': 'Is Active',
  'pages.component.validation.codeRequired': 'Code is required',
  'pages.component.validation.nameRequired': 'Name is required',
  'pages.component.active': 'Active',
  'pages.component.inactive': 'InActive',
  'pages.component.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.component.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.component.message.newRecordRemoved': 'New record removed successfully',
  'pages.component.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.component.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.component.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.component.message.noChangesToSync': 'No changes to sync',
  'pages.component.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.component.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.component.message.fetchError': 'Failed to fetch components',
  'pages.component.refresh.success': 'Data refreshed successfully.',
  'pages.component.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.component.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.component.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.component.refresh.tooltip.normal': 'Refresh data from server',

  // ComponentGroup Detail
  'pages.componentGroup.title': 'Component Group Detail',
  'pages.componentGroup.column.code': 'Code',
  'pages.componentGroup.column.name': 'Name',
  'pages.componentGroup.column.productId': 'Product',
  'pages.componentGroup.column.productName': 'Product Name',
  'pages.componentGroup.column.isActive': 'Is Active',
  'pages.componentGroup.validation.codeRequired': 'Code is required',
  'pages.componentGroup.validation.nameRequired': 'Name is required',
  'pages.componentGroup.active': 'Active',
  'pages.componentGroup.inactive': 'InActive',
  'pages.componentGroup.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.componentGroup.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.componentGroup.message.newRecordRemoved': 'New record removed successfully',
  'pages.componentGroup.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.componentGroup.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.componentGroup.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.componentGroup.message.noChangesToSync': 'No changes to sync',
  'pages.componentGroup.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.componentGroup.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.componentGroup.message.fetchError': 'Failed to fetch component groups',
  'pages.componentGroup.refresh.success': 'Data refreshed successfully.',
  'pages.componentGroup.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.componentGroup.refresh.confirm': 'You have {count} unsaved changes. Refreshing will discard all changes. Are you sure you want to continue?',
  'pages.componentGroup.refresh.tooltip': 'Refresh will discard {count} unsaved changes',
  'pages.componentGroup.refresh.tooltip.normal': 'Refresh data from server',

  'common.yes': 'Yes',
  'common.no': 'No',

  // ---- i18n audit 2026-09-03: fill missing keys (had defaultMessage fallbacks, silenced console warnings) ----
  'pages.UOM.title': 'UOM Detail',
  'pages.accountgroup.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.address.column.level': 'Level',
  'pages.address.column.parent': 'Parent',
  'pages.address.message.failedToDelete': 'Failed to delete record',
  'pages.address.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.address.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.address.select.parent.placeholder': 'Select parent (lower level)',
  'pages.address.validation.levelRequired': 'Level is required',
  'pages.address.validation.parentRequired': 'Parent is required for level > 1',
  'pages.address.validation.tooltip': 'Fix required fields (code, name, level, parent for level>1)',
  'pages.addressDetail.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.addressDetail.message.childRecordCreated': 'Child record created with default address. You can edit it below.',
  'pages.addressDetail.message.failedToDelete': 'Failed to delete record',
  'pages.addressDetail.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.addressDetail.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.addressDetail.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.addressDetail.message.newRecordRemoved': 'New record removed successfully',
  'pages.addressDetail.message.newRowAddedSuccessfully': 'New row added (same level). Start typing to fill in the details.',
  'pages.addressDetail.message.noChangesToSync': 'No changes to sync',
  'pages.addressDetail.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.brand.message.failedToDelete': 'Failed to delete record',
  'pages.brand.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.brand.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.calendar.message.failedToDelete': 'Failed to delete record',
  'pages.calendar.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.calendar.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.calendar.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.calendarCustomize.message.failedToDelete': 'Failed to delete record',
  'pages.calendarCustomize.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.calendarCustomize.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.calendarcustomize.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.category.message.failedToDelete': 'Failed to delete record',
  'pages.category.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.color.message.failedToDelete': 'Failed to delete record',
  'pages.color.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.color.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.component.message.failedToDelete': 'Failed to delete record',
  'pages.component.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.componentGroup.message.failedToDelete': 'Failed to delete record',
  'pages.componentGroup.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.currency.message.failedToDelete': 'Failed to delete record',
  'pages.currency.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.currency.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.customer.message.failedToDelete': 'Failed to delete record',
  'pages.customer.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.customer.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.customer.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.customerType.message.failedToDelete': 'Failed to delete record',
  'pages.customerType.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.customerType.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.customertype.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.deliveryTerm.message.failedToDelete': 'Failed to delete record',
  'pages.deliveryTerm.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.deliveryTerm.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.deliveryterm.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.employee.message.failedToDelete': 'Failed to delete record',
  'pages.employee.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.employee.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.employee.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.employee.personInCharge.select': 'Select type',
  'pages.employeeType.active': 'Active',
  'pages.employeeType.column.code': 'Code',
  'pages.employeeType.column.isActive': 'Is Active',
  'pages.employeeType.column.name': 'Name',
  'pages.employeeType.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.employeeType.inactive': 'InActive',
  'pages.employeeType.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.employeeType.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.employeeType.message.fetchError': 'Failed to fetch employee types',
  'pages.employeeType.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.employeeType.message.newRecordRemoved': 'New record removed successfully',
  'pages.employeeType.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.employeeType.message.noChangesToSync': 'No changes to sync',
  'pages.employeeType.message.recordMarkedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.employeeType.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.employeeType.refresh.success': 'Data refreshed successfully.',
  'pages.employeeType.title': 'Employee Type Detail',
  'pages.employeeType.validation.codeRequired': 'Code is required',
  'pages.employeeType.validation.nameRequired': 'Name is required',
  'pages.employeetype.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.holiday.message.failedToDelete': 'Failed to delete record',
  'pages.holiday.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.holiday.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.jobPosition.message.failedToDelete': 'Failed to delete record',
  'pages.jobPosition.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.lightSource.message.failedToDelete': 'Failed to delete record',
  'pages.lightSource.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.line.message.failedToDelete': 'Failed to delete record',
  'pages.line.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.line.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.machine.message.failedToDelete': 'Failed to delete record',
  'pages.machine.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.machine.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.machineType.active': 'Active',
  'pages.machineType.column.code': 'Code',
  'pages.machineType.column.isActive': 'Is Active',
  'pages.machineType.column.name': 'Name',
  'pages.machineType.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.machineType.inactive': 'InActive',
  'pages.machineType.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.machineType.message.failedToDelete': 'Failed to delete record',
  'pages.machineType.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.machineType.message.fetchError': 'Failed to fetch machine types',
  'pages.machineType.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.machineType.message.newRecordRemoved': 'New record removed successfully',
  'pages.machineType.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.machineType.message.noChangesToSync': 'No changes to sync',
  'pages.machineType.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.machineType.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.machineType.refresh.success': 'Data refreshed successfully.',
  'pages.machineType.title': 'Machine Type Detail',
  'pages.machineType.validation.codeRequired': 'Code is required',
  'pages.machineType.validation.nameRequired': 'Name is required',
  'pages.machinetype.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.materialType.active': 'Active',
  'pages.materialType.button.syncWfx': 'Sync WFX',
  'pages.materialType.column.code': 'Code',
  'pages.materialType.column.isActive': 'Is Active',
  'pages.materialType.column.name': 'Name',
  'pages.materialType.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.materialType.inactive': 'InActive',
  'pages.materialType.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.materialType.message.failedToDelete': 'Failed to delete record',
  'pages.materialType.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.materialType.message.fetchError': 'Failed to fetch material types',
  'pages.materialType.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.materialType.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.materialType.message.newRecordRemoved': 'New record removed successfully',
  'pages.materialType.message.noChangesToSync': 'No changes to sync',
  'pages.materialType.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.materialType.message.syncWfxFailed': 'Failed to sync material types from WFX',
  'pages.materialType.message.syncWfxSuccess': 'Material types synced from WFX successfully',
  'pages.materialType.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.materialType.refresh.success': 'Data refreshed successfully.',
  'pages.materialType.title': 'Material Type',
  'pages.materialType.validation.codeRequired': 'Code is required',
  'pages.materialType.validation.nameRequired': 'Name is required',
  'pages.operationLibrary.active': 'Active',
  'pages.operationLibrary.column.code': 'Code',
  'pages.operationLibrary.column.isActive': 'Is Active',
  'pages.operationLibrary.column.level': 'Level',
  'pages.operationLibrary.column.name': 'Name',
  'pages.operationLibrary.column.parent': 'Parent',
  'pages.operationLibrary.delete.confirm': 'Are you sure you want to delete this record?',
  'pages.operationLibrary.inactive': 'InActive',
  'pages.operationLibrary.message.changesSyncedSuccessfully': 'Changes synced successfully',
  'pages.operationLibrary.message.failedToDelete': 'Failed to delete record',
  'pages.operationLibrary.message.failedToSyncChanges': 'Failed to sync changes',
  'pages.operationLibrary.message.fetchError': 'Failed to fetch operation libraries',
  'pages.operationLibrary.message.fixValidationErrors': 'Please fix validation errors before saving',
  'pages.operationLibrary.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.operationLibrary.message.newRecordRemoved': 'New record removed successfully',
  'pages.operationLibrary.message.newRowAddedSuccessfully': 'New row added. Start typing to fill in the details.',
  'pages.operationLibrary.message.noChangesToSync': 'No changes to sync',
  'pages.operationLibrary.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.operationLibrary.refresh.error': 'Failed to refresh data. Please try again.',
  'pages.operationLibrary.refresh.success': 'Data refreshed successfully.',
  'pages.operationLibrary.select.parent.placeholder': 'Select parent (lower level)',
  'pages.operationLibrary.title': 'Operation Library',
  'pages.operationLibrary.validation.codeRequired': 'Code is required',
  'pages.operationLibrary.validation.levelRequired': 'Level is required',
  'pages.operationLibrary.validation.nameRequired': 'Name is required',
  'pages.operationLibrary.validation.parentRequired': 'Parent is required for level > 1',
  'pages.operationLibrary.validation.tooltip': 'Fix required fields (code, name, level, parent for level>1)',
  'pages.organization.message.failedToDelete': 'Failed to delete record',
  'pages.organization.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.organization.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.organizationDetail.message.failedToDelete': 'Failed to delete record',
  'pages.organizationDetail.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.origin.message.failedToDelete': 'Failed to delete record',
  'pages.origin.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.paymentTerm.message.failedToDelete': 'Failed to delete record',
  'pages.paymentTerm.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.paymentterm.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.port.message.failedToDelete': 'Failed to delete record',
  'pages.port.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.port.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.product.column.categoryId': 'Category',
  'pages.product.column.colorIds': 'Color',
  'pages.product.column.shrinkage': 'Shrinkage',
  'pages.product.column.sizeIds': 'Size',
  'pages.product.column.stitchCount': 'Stitch Count',
  'pages.product.column.yarnCount': 'Yarn Count',
  'pages.product.message.failedToDelete': 'Failed to delete record',
  'pages.product.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.product.refresh.warning': 'Data saved but refresh failed. Please refresh manually.',
  'pages.productCategory.message.failedToDelete': 'Failed to delete record',
  'pages.productCategory.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.productGroup.column.category': 'Category',
  'pages.productGroup.message.failedToDelete': 'Failed to delete record',
  'pages.productGroup.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.section.column.allowedCategories': 'Allowed Categories',
  'pages.section.message.failedToDelete': 'Failed to delete record',
  'pages.section.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.section.placeholder.allowedCategories': 'Select allowed product categories',
  'pages.shipmentTerm.message.failedToDelete': 'Failed to delete record',
  'pages.shipmentTerm.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.shipmentterm.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.site.message.failedToDelete': 'Failed to delete record',
  'pages.site.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.site.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.size.message.failedToDelete': 'Failed to delete record',
  'pages.size.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.size.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.subCategory.column.productGroup': 'Product Group',
  'pages.subCategory.message.failedToDelete': 'Failed to delete record',
  'pages.subCategory.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.supplier.message.failedToDelete': 'Failed to delete record',
  'pages.supplier.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.supplier.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.supplierType.message.failedToDelete': 'Failed to delete record',
  'pages.supplierType.message.recordDeletedSuccessfully': 'Record deleted successfully',
  'pages.suppliertype.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.uom.message.failedToDelete': 'Failed to delete record',
  'pages.uom.message.multipleRowsAdded': '{count} row(s) added. Start typing to fill in the details.',
  'pages.uom.message.recordDeletedSuccessfully': 'Record deleted successfully',
};
